import React from 'react';

import Content from './Shared/Content';
import Iconography, { getIconography } from './Shared/Iconography';

/**
 * @type {React.FC<import('modules/notifications/types').Notification>}
 */
const DefaultNotification = notification => {
  const [icon] = getIconography(notification);

  return (
    <React.Fragment>
      <Iconography icon={icon} />
      <Content {...notification} />
    </React.Fragment>
  );
};

export default DefaultNotification;
